class ReactSendMessage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            people: Immutable.List(), // as received from getAll()
            visible: false,
            errorNotification: null,
            successNotification: null,
            active: false,
            showSendMessageEmailOverride: props.showSendMessageEmailOverride,
            subject: '',
            uniqueId: Math.random()
        }
    }

    /**
     * Needs an array with person ids to send the message to.
     * "subject" is optional, used to populate the subject field
     */
    show(personIds, subject) {
        this.setState({
            people: Immutable.List(),
            visible: true,
            errorNotification: null,
            successNotification: null,
            subject: subject
        });
        this._load(personIds);
    }

    _hide() {
        this.setState({visible: false});
    }

    _load(personIds) {
        $.ajax({
            url: SS.route('People', 'People', 'getAll', null),
            data: {
                id: personIds.join(',')
            },
            dataType: 'json',
            cache: false,
            success: function (data) {
                this.setState({
                    people: Immutable.fromJS(data[data.metaData.root])
                });
            }.bind(this),
            error: function (xhr, status, err) {
                alert(xhr.responseText);
            }
        })
    }

    _send() {
        var me = this,
            peopleIds = this._getPeopleIds();

        this.setState({
            errorNotification: null
        });

        if (peopleIds && peopleIds.length > 0 && this.refs.subject.value.length > 0 && this.refs.message.value.length > 0) {

            this.setState({
                active: true
            });
            var sendData = {
                to: peopleIds,
                subject: this.refs.subject.value,
                body: this.refs.message.value
            }

            if (this.state.showSendMessageEmailOverride) {
                sendData['send_email'] = this.refs.send_email_override.checked ? 1 : 0;
            }

            $.ajax({
                url: SS.route('Messages', 'MessagesConversations', 'startConversation', null),
                data: sendData,
                method: 'POST',
                dataType: 'json',
                cache: false,
                success: function (data) {

                    me.setState({
                        active: false,
                        successNotification: "Your message has been sent"
                    });

                    setTimeout(function () {
                        me._hide();
                    }, 3000);

                }.bind(this),
                error: function (xhr, status, err) {
                    alert(xhr.responseText);
                }
            })
        } else {
            this.setState({
                errorNotification: "Please fill out all fields"
            });
        }

    }

    _getPeopleNames() {
        var res = [];
        this.state.people.forEach(function (r) {
            res.push(r.get('Person').get('fullname') + ' (' + r.get('Person').get('email') + ')');
        });
        return res;
    }

    _getPeopleIds() {
        var res = [];
        this.state.people.forEach(function (r) {
            res.push(r.get('Person').get('id'));
        });
        return res;
    }

    render() {
        var state = this.state;

        // Get centered or absolute popup class (available: 'popup-full-view', 'popup-centered', 'popup-absolute')
        var popupClass = $(document).scrollTop() > 100 ? 'popup-centered' : 'popup-absolute';

        return (
            <div className="global-react-popup-wrapper">
                <div
                    className={'global-react-popup send-message-popup ' + (popupClass) + (state.visible ? ' visible' : '')}>
                    <i className="close" onClick={this._hide.bind(this)}/>
                    <div className="content-wrapper">
                        <div className="content">
                            <div className="content-inner">
                                <h3 className="title">Send Message</h3>
                                <div className="form-holder">
                                    <div className="field-group field-group-person-to even">
                                        <div className="field-group-inner">
                                            <label htmlFor={"form-field-person-to-1-" + this.state.uniqueId}>To</label>
                                            <div className="field-holder">
                                                {/* TODO: Review warning || react-dom.development.js:3115 Warning: Failed prop type: You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.*/}
                                                <input defaultValue={this._getPeopleNames().join(', ')} type="text"
                                                       id={"form-field-person-to-1-" + this.state.uniqueId} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field-group field-group-subject odd">
                                        <div className="field-group-inner">
                                            <label
                                                htmlFor={"form-field-subject-1-" + this.state.uniqueId}>Subject</label>
                                            <div className="field-holder">
                                                {/* TODO: Review warning || react-dom.development.js:3115 Warning: Failed prop type: You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.*/}
                                                <input defaultValue={this.state.subject} type="text"
                                                       id={"form-field-subject-1-" + this.state.uniqueId}
                                                       ref="subject" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field-group field-group-message even">
                                        <div className="field-group-inner">
                                            <label htmlFor="form-field-message-1">Message</label>
                                            <div className="field-holder">
                                                <textarea id="form-field-message-1" ref="message"/>
                                            </div>
                                        </div>
                                    </div>
                                    {state.showSendMessageEmailOverride ?
                                        <div className="field-group field-group-email-override odd">
                                            <label className='c-input c-checkbox'>
                                                <input ref="send_email_override"
                                                       type="checkbox"/>
                                                <span className="c-indicator"/>
                                                <span className="c-label">Send Email</span>
                                            </label>
                                        </div>
                                        : undefined}
                                    <div className="clearfix"></div>

                                    {state.errorNotification ? <div
                                        className="form-notification form-error">{state.errorNotification}</div> : undefined}
                                    {state.successNotification ? <div
                                        className="form-notification form-success">{state.successNotification}</div> : undefined}

                                    <div className="form-actions">
                                        <a
                                            onClick={this._send.bind(this)}
                                            className={'btn btn-primary save' + (!state.people.size || state.active == true ? ' disabled' : '')}
                                            role="button"
                                        >
                                            {!state.people.size || state.active == true ? 'Loading...' : 'Send'}
                                        </a>
                                        <a onClick={this._hide.bind(this)} className="btn btn-link cancel"
                                           role="button">Cancel</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'global-react-popup-overlay ' + (popupClass) + (state.visible ? ' visible' : '')}></div>
            </div>
        )
    }
}
